// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck all this dynamic registration is just too much for typescript

// See https://github.com/highcharts/highcharts/issues/6086 and
// https://stackoverflow.com/questions/42076332/uncaught-typeerror-e-dodrilldown-is-not-a-function-highcharts
// to understand why this is being done
import Highcharts from 'highcharts';
import Highmaps from 'highcharts/modules/map';
import Highstock from 'highcharts/modules/stock';
import Drilldown from 'highcharts/modules/drilldown';
import More from 'highcharts/highcharts-more';
import NoData from 'highcharts/modules/no-data-to-display';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Bullet from 'highcharts/modules/bullet';
import borderRadius from 'highcharts-border-radius';
import exporting from 'highcharts/modules/exporting';
import Treemap from 'highcharts/modules/treemap';
if (typeof Highcharts === 'object') {
  borderRadius(Highcharts);
  Highmaps(Highcharts);
  Highstock(Highcharts);
  Highcharts.SVGRenderer.prototype.symbols.download = () => {
    return ['M5.003418,13c-0.5512695,0-1-0.4482422-1-1s0.4487305-1,1-1s1,0.4482422,1,1 S5.5546875,13,5.003418,13z', 'M17.996582,12c0,0.5517578,0.4487305,1,1,1s1-0.4482422,1-1s-0.4487305-1-1-1 S17.996582,11.4482422,17.996582,12z', 'M11.003418,12c0,0.5517578,0.4487305,1,1,1s1-0.4482422,1-1s-0.4487305-1-1-1 S11.003418,11.4482422,11.003418,12z'];
  };
  if (!Highcharts.Chart.prototype.addSeriesAsDrilldown) {
    Drilldown(Highcharts);
  }
  if (!Highcharts.seriesTypes.gauge) {
    More(Highcharts);
  }
  if (!Highcharts.Chart.prototype.hideNoData) {
    NoData(Highcharts);
  }
  if (!Highcharts.seriesTypes.solidgauge) {
    SolidGauge(Highcharts);
  }
  if (!Highcharts.seriesTypes.bullet) {
    Bullet(Highcharts);
  }
  if (!Highcharts.Chart.prototype.exporting) {
    exporting(Highcharts);
  }
  if (!Highcharts.seriesType.Treemap) {
    Treemap(Highcharts);
  }
}
export default Highcharts;